
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/explore-homeowner-resources",
      function () {
        return require("private-next-pages/features/explore-homeowner-resources.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/explore-homeowner-resources"])
      });
    }
  